<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>网站设置</el-breadcrumb-item>
    </el-breadcrumb>
    <h1 class="view-head">
      网站设置
    </h1>
    <div class="view-content">
      <el-card class="box-card">
        <div class="card-content">
          <div class="table-tool">共{{ totalCount }}条</div>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="client_name" label="商业公司名称">
            </el-table-column>
            <el-table-column prop="website_address" label="网站">
            </el-table-column>
            <el-table-column prop="broker_code" label="经销商编码">
            </el-table-column>
            <el-table-column prop="broker_name" label="经销商名称">
            </el-table-column>
            <el-table-column prop="scrap_type" label="抓取类型">
              <template slot-scope="scope">
                <span>{{ scrap[scope.row.scrap_type] }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="function_status" label="状态">
              <template slot-scope="scope">
                <el-tag
                  :type="'success'"
                  v-if="scope.row.function_status === 1"
                  disable-transitions
                  >正常</el-tag
                >
                <el-tag
                  :type="'danger'"
                  v-if="scope.row.function_status === 2"
                  disable-transitions
                  >失效</el-tag
                >
                <el-tag
                  :type="'info'"
                  v-if="!scope.row.function_status"
                  disable-transitions
                  >暂未匹配</el-tag
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="operation"
              label="操作"
              width="200"
              v-if="$store.state.funcModuleArray.includes(1901020101)"
            >
              <template slot-scope="scope">
                <!--                <el-button-->
                <!--                  @click.native.prevent="openDialog('rowEdit',{row:scope.row,index:scope.$index})"-->
                <!--                  type="text"-->
                <!--                  size="small">-->
                <!--                  设置账号-->
                <!--                </el-button>-->
                <el-button
                  @click.native.prevent="
                    openChooseDealer(scope.$index, scope.row)
                  "
                  type="text"
                  size="small"
                  v-if="$store.state.funcModuleArray.includes(1901020101)"
                >
                  选择经销商
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </div>
    <!--    设置账号-->
    <el-dialog title="设置账号" :visible.sync="dialog.rowEdit.visible">
      <el-form
        ref="rowEditForm"
        :model="rowEditForm"
        :rules="rowEditRules"
        label-width="96px"
      >
        <el-form-item label="登录账号" prop="username">
          <el-input v-model="rowEditForm.username"></el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="password">
          <el-input v-model="rowEditForm.password"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialog.rowEdit.visible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="rowEditSave('rowEditForm')"
          :loading="dialog.rowEdit.isLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!--    选择经销商-->
    <choose-dealer
      ref="chooseDealer"
      @saveChange="clientAddSaveChange"
      :is-checkbox="false"
      :is-clear-search-text="true"
      :type="4"
    ></choose-dealer>

    <el-dialog
      title="提示"
      :visible.sync="configmForce.visible"
      :width="'500px'"
    >
      {{ configmForce.msg }}
      <span slot="footer" class="dialog-footer">
        <el-button @click="configmForce.visible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="onWebscrapSetBroker(1)"
          :loading="configmForce.isLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  webscrapGetList,
  saveWebscrap,
  webscrapGetAccount,
  webscrapSetBroker
} from "@/api/index";
import ChooseDealer from "@/components/ChooseDealer";

export default {
  name: "directWebManage",
  components: {
    ChooseDealer
  },
  data: () => ({
    currentPage: 1,
    tableData: [],
    totalCount: 0,
    dialog: {
      rowEdit: {
        visible: false,
        isLoading: false,
        row: {}
      }
    },
    changeClientRow: {
      index: "",
      row: ""
    },
    rowEditForm: {
      username: "",
      password: ""
    },
    rowEditRules: {
      username: [
        { required: true, message: "请输入登录账号", trigger: "blur" }
        // {max: 50, message: '最多50个字符', trigger: 'blur'}
      ],
      password: [
        { required: true, message: "请输入登录密码", trigger: "blur" }
        // {
        //   pattern: /^([a-z0-9\.\@\!\#\$\%\^\&\*\(\)\-\_]){6,16}$/i,
        //   message:
        //     '6~16位,数字、字母、特殊字符：.\@!#$%^&*()-_'
        // },
      ]
    },

    scrap: {
      1: "网站抓取",
      2: "Web service"
    },
    configmForce: {
      visible: false,
      msg: "",
      isLoading: false
    }
  }),
  created() {
    this._getList();
  },
  methods: {
    _getList() {
      webscrapGetList().then(res => {
        if (0 === res.status) {
          this.tableData = res.data;
          this.totalCount = res.data.length;
        } else {
          this.totalCount = 0;
          this.tableData = [];
        }
      });
    },
    openChooseDealer(index, row) {
      this.changeClientRow = {
        index,
        row
      };
      this.$refs.chooseDealer.openDialog();
    },
    clientAddSaveChange(selectionVal) {
      const clientInfo = selectionVal[0];
      const changeClientRow = this.changeClientRow;
      this.clientInfo = selectionVal[0];
      this.onWebscrapSetBroker();
    },
    onWebscrapSetBroker(is_force_set = 0) {
      this.configmForce.isLoading = true;
      webscrapSetBroker({
        client_code: this.changeClientRow.row.client_code,
        client_name: this.changeClientRow.row.client_name,
        broker_name: this.clientInfo.name,
        broker_code: this.clientInfo.client_code,
        client_id: this.clientInfo.client_id,
        is_force_set
      }).then(res => {
        this.configmForce = {
          visible: false,
          msg: "",
          isLoading: false
        };
        if (0 === res.status) {
          this.$message({
            message: res.msg,
            type: "success"
          });
          const index = this.changeClientRow.index;
          this.tableData[index].broker_name = this.clientInfo.name;
          this.tableData[index].broker_code = this.clientInfo.client_code;
        } else if (res.status == 4) {
          this.configmForce = {
            visible: true,
            msg: res.msg,
            isLoading: false
          };
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    openDialog(dialogName, e) {
      if (e) {
        this.dialog[dialogName].e = { ...e };
        // 编辑
        if (dialogName === "rowEdit") {
          if (this.$refs["rowEditForm"]) {
            this.$refs["rowEditForm"].resetFields();
          }
          webscrapGetAccount(e.row.client_code).then(res => {
            if (0 === res.status) {
              this.rowEditForm = {
                username: res.data.login_name,
                password: res.data.password
              };
            } else {
              this.rowEditForm = {
                username: "",
                password: ""
              };
            }
            this.dialog[dialogName].visible = true;
          });
        } else {
          this.dialog[dialogName].visible = true;
        }
      } else {
        this.dialog[dialogName].visible = true;
      }
    },
    rowEditSave(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.dialog.rowEdit.isLoading = true;
          const e = this.dialog.rowEdit.e;
          let values = { ...this[formName] };
          const parameter = {
            client_code: e.row.client_code,
            client_name: e.row.client_name,
            login_name: values.username,
            password: values.password
          };

          saveWebscrap(parameter).then(res => {
            this.dialog.rowEdit.isLoading = false;
            if (0 === res.status) {
              this.dialog.rowEdit.visible = false;
              this.$message({
                message: res.msg,
                type: "success"
              });
              // this.tableData[e.index].client_plugin_name = values.username;
              // this.tableData[e.index].client_plugin_password = values.password;
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    }
  }
};
</script>

<style scoped></style>
